import React from 'react'
import { mount } from 'enzyme'
import SubNavLink from '../SubNavLink'

describe('<SubNavLink />', () => {
  let wrapper, props
  describe('when its link prop has no href attribute', () => {
    beforeEach(() => {
      props = {
        link: {
          title: 'Test Title'
        }
      }
      wrapper = mount(<SubNavLink {...props} />)
    })
    it('should return a <TitleContainer /> with the title prop', () => {
      expect(wrapper.find('SubNavLink__TitleContainer').text()).toBe(props.link.title)
    })
  })
  describe('when the link prop has an href attribute', () => {
    beforeEach(() => {
      props = {
        link: {
          href: 'google.com',
          title: 'test title'
        }
      }
      wrapper = mount(<SubNavLink {...props} />)
    })
    it('should return a <Link /> with the provided href', () => {
      expect(wrapper.find('SubNavLink__Link').prop('href')).toBe(props.link.href)
    })
    it('should return a <Link /> with the provided title', () => {
      expect(wrapper.find('SubNavLink__Link').text()).toBe(props.link.title)
    })
  })
})
